import apiClient, { tokenStorage } from "./client";
import type {
  OtpPurpose,
  RegisterPayload,
  ResetPasswordPayload,
  TokenPair,
  User,
} from "@/types";

/**
 * Centralized authentication API (mobile + SMS OTP).
 */

export async function sendOtp(
  phone_number: string,
  purpose: OtpPurpose
): Promise<void> {
  await apiClient.post("/auth/otp/send", { phone_number, purpose });
}

export async function verifyOtp(
  phone_number: string,
  code: string,
  purpose: OtpPurpose
): Promise<string> {
  const { data } = await apiClient.post<{ verification_token: string }>(
    "/auth/otp/verify",
    {
      phone_number,
      code,
      purpose,
    }
  );
  return data.verification_token;
}

export async function login(
  phone_number: string,
  password: string
): Promise<TokenPair> {
  const { data } = await apiClient.post<TokenPair>("/auth/login", {
    phone_number,
    password,
  });
  tokenStorage.set(data);
  return data;
}

export async function register(payload: RegisterPayload): Promise<TokenPair> {
  const { data } = await apiClient.post<TokenPair>("/auth/register", payload);
  tokenStorage.set(data);
  return data;
}

export async function forgotPassword(phone_number: string): Promise<void> {
  await apiClient.post("/auth/forgot-password", {
    phone_number,
    purpose: "password_reset",
  });
}

export async function resetPassword(
  payload: ResetPasswordPayload
): Promise<void> {
  await apiClient.post("/auth/reset-password", payload);
}

export async function refresh(): Promise<TokenPair> {
  const refresh_token = tokenStorage.getRefresh();
  const { data } = await apiClient.post<TokenPair>("/auth/refresh", {
    refresh_token,
  });
  tokenStorage.set(data);
  return data;
}

export async function getCurrentUser(): Promise<User> {
  const { data } = await apiClient.get<User>("/auth/me");
  return data;
}

export function logout(): void {
  tokenStorage.clear();
}
